export default "__VITE_ASSET__Cgti3rb4__"